<template>
    <div class="card p-shadow-app">
        <Toast :style="{ width: $isMobile() ? '85vw' : '' }" />
        <Loading :active.sync="loading" :isFullPage="true"></Loading>
        <div class="card p-shadow-app">
            <header class="jumbotron">
                <h3>Solicitação de Documentos - Configurações</h3>
            </header>
            <form id="NotificationEMAIL" name="NotificationEMAIL" class="p-col-12 p-md-12" @submit.prevent="save">

                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-mt-3 p-field p-col-12 p-md-4">
                        <div class="p-mb-1"><b>Ativar Template</b></div>
                        <Checkbox v-model="form.is_active" :binary="true" class="p-mt-2" />
                    </div>
                </div>

                <h5>Mensagem</h5>
                <hr />

                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-6">
                        <label>Nome do Template</label>
                        <InputText v-model="form.name" required />
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label>Descrição</label>
                        <InputText v-model="form.description" />
                    </div>
                </div>

                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-12">
                        <label class="p-mb-2"><b>Conteúdo da Mensagem</b></label>
                        <div class="p-mb-2">
                            <small>{{ plainTextLength }} caracteres</small>
                        </div>
                        <AppTemplateEditor
                          :content.sync="form.content"
                          :tags="availableTags"
                          placeholder="Escreva a sua mensagem..."
                          @update:text="handleTextUpdate"
                        />
                    </div>
                </div>

                <h5>Ignorar Clientes</h5>
                <p>
                  Os clientes listados abaixo <b>não receberão</b> esta notificação.
                </p>

                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-field p-col-12 p-md-12">
                    <label>Adicionar Cliente à lista de exclusão</label>
                    <AppAutocomplete
                      :fieldId="'clientSelector'"
                      :optionLabel="getClientLabel"
                      optionValue="id"
                      v-model="clientToAdd"
                      :fetchFunction="fetchClients"
                      placeholder="Pesquise por nome, email ou NIF..."
                      @selection-change="addClientToIgnore"
                      appendTo="body"
                    >
                      <template #option="slotProps">
                        <div>
                          <b>{{ slotProps.option.name }}</b><br />
                          <span style="white-space: normal; word-break: break-word; font-size: 0.85em; color: #666;">
                            <span v-if="slotProps.option.email">EMAIL: {{ slotProps.option.email }} | </span>
                            <span v-if="slotProps.option.fiscalNumber">NIF: {{ slotProps.option.fiscalNumber }}</span>
                          </span>
                        </div>
                      </template>
                    </AppAutocomplete>
                  </div>

                  <div class="p-col-12" v-if="form.ignored_clients && form.ignored_clients.length > 0">
                      <DataTable :value="form.ignored_clients"
                        :key="renderComponentKey"
                        class="p-datatable-sm"
                        :rowHover="true"
                        responsiveLayout="scroll"
                        :scrollable="true"
                        scrollHeight="flex">
                          <Column field="id" header="No"></Column>
                          <Column field="name" header="Nome"></Column>
                          <Column field="email" header="Email"></Column>
                          <Column field="fiscalNumber" header="NIF"></Column>
                          <Column header="Ações" headerStyle="width: 100px; text-align: center" bodyStyle="text-align: center">
                              <template #body="slotProps">
                                  <Button
                                      icon="pi pi-trash"
                                      class="p-button-rounded p-button-danger p-button-text"
                                      @click="removeClientFromIgnore(slotProps.data)"
                                      tooltip="Remover da lista"
                                  />
                              </template>
                          </Column>
                      </DataTable>
                  </div>

                  <div class="p-col-12" v-else>
                      <div class="box-empty p-p-3 p-text-center">
                          <small>Nenhum cliente ignorado. A notificação será enviada para todos.</small>
                      </div>
                  </div>
                </div>

                <h5>Autorização da página de documentos</h5>
                <p>
                  De acordo com os estados selecionados, será exibido a página com o formulário.
                </p>

                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-field p-col-12 p-md-3">
                    <label for="patStatus">Estado</label>
                    <Dropdown
                      id="patStatus"
                      :options="patStatus"
                      v-model="selectedStatus"
                      :multiple="true"
                      optionLabel="field"
                      optionValue="field"
                      name="patStatus"
                      v-validate="'required'"
                      :class="{ 'p-invalid': errors.has('patStatus') }"
                      placeholder="Selecionar Estado"
                      @change="addState"
                      filter
                      appendTo="body"
                    />
                    <span v-if="errors.has('patStatus')" class="p-error">
                      Estado do PAT é Obrigatório
                    </span>
                  </div>

                  <div class="p-col-12" v-if="form.metadata && form.metadata.status.length > 0">
                      <DataTable :value="statusTableData" :key="statusRenderComponentKey" class="p-datatable-sm">
                          <Column field="label" header="Nome"></Column>
                          <Column header="Ações" headerStyle="width: 100px; text-align: center" bodyStyle="text-align: center">
                              <template #body="slotProps">
                                  <Button
                                      icon="pi pi-trash"
                                      class="p-button-rounded p-button-danger p-button-text"
                                      @click="removeState(slotProps.data)"
                                      tooltip="Remover da lista"
                                  />
                              </template>
                          </Column>
                      </DataTable>
                  </div>

                  <div class="p-col-12" v-else>
                      <div class="box-empty p-p-3 p-text-center">
                          <small>Nenhum estado disponível</small>
                      </div>
                  </div>

                </div>

                <div class="p-mt-5 p-text-right">
                    <Button label="Testar Email" icon="pi pi-send" class="p-button-info p-mr-2" type="button" @click.prevent="openTestDialog" :disabled="loading" />
                    <Button label="Gravar Configuração" icon="pi pi-save" class="p-button-success" type="submit" :loading="loading" />
                </div>
            </form>
        </div>

        <Dialog header="Testar Envio de Email" :visible.sync="testDialogVisible" :modal="true" :closable="true" :style="{ width: $isMobile() ? '95vw' : '50vw' }">
             <div class="p-fluid">
                <div class="p-field">
                    <label>E-mail</label>
                    <InputText v-model="testForm.recipient" placeholder="email@example.com" />
                </div>
                 <div class="p-d-flex p-jc-end p-mt-3">
                     <Button label="Enviar Teste" icon="pi pi-send" @click="sendTest" :loading="testLoading" />
                 </div>
            </div>
        </Dialog>
    </div>
</template>

<script>
import AppTemplateEditor from '../components/elements/AppTemplateEditor.vue';
import notificationsService from '../services/notifications.service';
import Loading from "vue-loading-overlay";
import PatService from '../services/pat.service';
import AppAutocomplete from '@/components/elements/AppAutocomplete.vue';
import clientService from "@/services/client.service";

export default {
  name: "NotificationSettingEmailRequestDocs",
  components: { Loading, AppTemplateEditor, AppAutocomplete },
  data() {
    return {
        loading: false,
        testLoading: false,
        testDialogVisible: false,
        providerId: null,
        templateId: null,
        plainTextContent: '',
        clientToAdd: null,
        renderComponentKey: 0,
        statusRenderComponentKey: 0,
        selectedStatus: null,

        form: {
            code: 'request-equipment-documentation',
            name: 'Solicitação de Documentos',
            description: '',
            content: '',
            metadata: {
              status: []
            },
            is_active: true,
            ignored_clients: []
        },

        availableActions: [],

        patStatus: [],
        listInternalStates: [],
        listConfirmInternalStates: [],

        testForm: { recipient: '', data: {} },
        testPreview: '',
        availableTags: [],
        replyRules: [],
    };
  },
  computed: {
    plainTextLength() { return this.plainTextContent.length; },
    statusTableData() {
        if (!this.form.metadata || !this.form.metadata.status) return [];
        return this.form.metadata.status.map(s => ({ label: s }));
    }
  },
  async created() {
    await this.loadStatuses();
    await this.loadProvider();
    await this.loadTemplate();
  },
  methods: {
    addState() {
      if (typeof this.form.metadata.status != 'object' || this.form.metadata.status === null) {
        this.form.metadata.status = [];
      }

      if (this.selectedStatus && !this.form.metadata.status.includes(this.selectedStatus)) {
        this.form.metadata.status.push(this.selectedStatus);
      }

      this.selectedStatus = null;
    },
    removeState(status) {
      const index = this.form.metadata.status.findIndex(s => s === status.label);
      if (index !== -1) {
        this.form.metadata.status.splice(index, 1);
        this.statusRenderComponentKey++;
      }
    },
    async addClientToIgnore(event) {
      const client = event;

      let clientData = await this.getCurrentClient(client);

      if (!clientData) return;

      const exists = this.form.ignored_clients.find(c => c.id === clientData.id);

      if (!exists) {
          this.form.ignored_clients.push(clientData);
      } else {
          this.$toast.add({ severity: 'warn', summary: 'Duplicado', detail: 'Este cliente já está na lista.', life: 2000 });
      }

      this.clientToAdd = null;
    },
    removeClientFromIgnore(client) {
      const index = this.form.ignored_clients.findIndex(c => c.id == client.id);

      if (index !== -1) {
          this.form.ignored_clients.splice(index, 1);

          this.form.ignored_clients = [...this.form.ignored_clients];
          this.renderComponentKey++;
      } else {
          console.warn('Cliente não encontrado na lista (verifique os IDs):', client.id);
      }
    },
    async fetchClients(search = '') {
      try {
        return await clientService.query({ search });
      } catch (error) {
        console.error('Error fetching clients:', error);
        return [];
      }
    },
    async getCurrentClient(clientNo) {
      try {
        const response = await clientService.query({ no: clientNo });
        return response.length ? response[0] : null;
      } catch (error) {
        console.error('Error fetching client:', error);
        return null;
      }
    },
    getClientLabel(client) {
      if (!client) return '';
      return `${client.name} | EMAIL: ${client.email} | NIF: ${client.fiscalNumber}`;
    },
    async loadStatuses() {
        try {
            const response = await PatService.getAllStatus();
            if (response) {
                this.patStatus = response;
            }
        } catch (e) { console.error(e); }
    },
    async loadProvider() {
        try {
            const response = await notificationsService.getAllProviders();
            if (response && response.data) {
                const emailProvider = response.data.find(p => p.code === 'email');
                if (emailProvider) {
                    this.providerId = emailProvider.id;
                    this.charLimit = emailProvider.char_limit || 290;
                    if (emailProvider.available_tags) {
                         this.availableTags = emailProvider.available_tags.map(tag => {
                            const nameMap = {
                              'nopat': 'Nº PAT',
                              'brand': 'Marca'
                            };
                            return { name: nameMap[tag] || tag, value: tag };
                        });
                    }
                }
            }
        } catch (e) { console.error(e); }
    },

    async loadTemplate() {
      this.loading = true;
      try {
        const response = await notificationsService.getTemplates('email');
        if (!response || !response.data) return;

        const template = response.data.templates.find(t => t.code === 'request-equipment-documentation');

        if (template) {
          this.templateId = template.id;
          this.form = {
            code: template.code,
            name: template.name,
            description: template.description || '',
            content: template.content,
            metadata: template.metadata || { status: [] },
            is_active: template.is_active
          };

          if (template.ignored_clients) {
              this.form.ignored_clients = template.ignored_clients.map(client => ({
                  id: client.client.id,
                  name: client.client ? client.client.name : 'N/A',
                  email: client.client ? client.client.email : 'N/A',
                  fiscalNumber: client.client ? client.client.fiscalNumber : 'N/A'
              }));
          } else {
              this.form.ignored_clients = [];
          }

          if (template.reply_rules) {
              this.replyRules = template.reply_rules.map(rule => ({
                  ...rule,
                  id: rule.id || Date.now() + Math.random()
              }));
          } else {
              this.replyRules = [];
          }
        }
      } catch (error) {
        this.$toast.add({ severity: 'error', summary: 'Erro', detail: 'Erro ao carregar template.' });
      } finally {
        this.loading = false;
      }
    },

    async save() {
      this.loading = true;
      try {
        const payload = {
            ...this.form,
            reply_rules: this.replyRules
        };

        let response;
        if (this.templateId) {
          response = await notificationsService.updateTemplate('email', this.templateId, payload);
        } else {
          response = await notificationsService.createTemplate('email', payload);
        }

        if (response) {
            this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: 'Configuração gravada!' });
            await this.loadTemplate();
        }
      } catch (error) {
        this.$toast.add({ severity: 'error', summary: 'Erro', detail: 'Erro ao gravar.' });
      } finally {
        this.loading = false;
      }
    },

    handleTextUpdate(text) { this.plainTextContent = text; },
    cancel() { this.loadTemplate(); },
    openTestDialog() {
      this.testForm.recipient = '';
      this.updateTestPreview();
      this.testDialogVisible = true;
    },

    updateTestPreview() {
      let preview = this.plainTextContent;
      this.testPreview = preview;
    },

    async sendTest() {
      if (!this.testForm.recipient) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Aviso',
          detail: 'Por favor, insira um email.',
          life: 3000
        });
        return;
      }

      if (!this.templateId) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Aviso',
          detail: 'Por favor, guarde o template antes de testar.',
          life: 3000
        });
        return;
      }

      this.testLoading = true;
      try {
        const response = await notificationsService.sendTestNotification(
          'email',
          this.templateId,
          this.testForm
        );
        if (response && response.success) {
          this.$toast.add({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'Email de teste enviado com sucesso!',
            life: 3000
          });
          this.testDialogVisible = false;
        } else {
          this.$toast.add({
            severity: 'error',
            summary: 'Erro',
            detail: 'Não foi possível enviar o email de teste.',
            life: 3000
          });
        }
      } catch (error) {
        this.$toast.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Não foi possível enviar o email de teste.',
          life: 3000
        });
      } finally {
        this.testLoading = false;
      }
    }
  },
  watch: {
    'testForm.data': {
      handler() {
        this.updateTestPreview();
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.p-error { color: #f44336; font-weight: 600; }
.p-text-warning { color: #ff9800; font-weight: 600; }
.text-muted { color: #6c757d; }

.box-rule {
    background-color: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    padding: 1rem;
    transition: all 0.2s;
}
.box-rule:hover {
    border-color: #ced4da;
    background-color: #fff;
}

.box-empty {
    border: 1px dashed #ced4da;
    border-radius: 6px;
    color: #6c757d;
    background-color: #f8f9fa;
}

.label-small {
    font-size: 0.85rem;
    font-weight: 600;
    color: #495057;
    display: block;
    margin-bottom: 0.3rem;
}

.list-enter-active, .list-leave-active { transition: all 0.3s; }
.list-enter, .list-leave-to { opacity: 0; transform: translateY(10px); }
</style>